import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import FormControl from "@mui/material/FormControl";
import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import RemoveCircleSharpIcon from "@mui/icons-material/RemoveCircleSharp";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Styles from "../../../../../Slices/Mof/Styles.json";
import ApiSetting from "../../../../../../Settings/ApiSettings.json";
import axios from "axios";
import Button from "@mui/material/Button";
import { useGlobalContext } from "../../../../../../context";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import DeleteSharpIcon from '@mui/icons-material/DeleteSharp';
import swal from 'sweetalert';

const urlParams = new URLSearchParams(window.location.search);
const myParam = urlParams.get("id");

// Import css files
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
function OtherBusinessFormList(props) {
  const [otherBusinessFormList, setOtherBusinessFormList] = useState([]);
  const [messageErrors, setMessageErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });
  const [snackBar2, setsnackBar2] = useState({
    open: false,
    vertical: "center",
    horizontal: "center",
    message: [],
    severity: "warning",
  });
  const [countImage, setCountImage] = useState([]);

  const {
    // loading,
    otherBusinessesList,
    fetchData,
  } = useGlobalContext();

  useEffect(() => {
    fetchData("OTHER_BUSINESSES_LIST", "other_businesses_list", {});
  }, []);
  console.log("otherBusinessesList", otherBusinessesList);
  //============format date to format yyyy-mm-dd============
  const formatDate = (date) => {
    if (!date) return null;
    let d = date;
    if (typeof d === 'string') {
      if (/^\d{4}-\d{2}-\d{2}$/.test(d)) return d; // already yyyy-MM-dd
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(d)) { // dd/MM/yyyy
        const [dd, mm, yyyy] = d.split('/');
        d = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
      } else {
        const parsed = new Date(d);
        d = isNaN(parsed.getTime()) ? null : parsed;
      }
    }
    if (!(d instanceof Date) || isNaN(d.getTime())) return null;

    let y = d.getFullYear();
    let m = d.getMonth() + 1;
    if (m < 10) m = "0" + m;

    let day = d.getDate();
    if (day < 10) day = "0" + day;

    return y + "-" + m + "-" + day;
  };

  const submit = async () => {
    // console.log("otherBusinessFormList",otherBusinessFormList);
    // return
    setMessageErrors([]);
    setLoading(true);
    let dataForm = new FormData();
    dataForm.append("Income_tax_report_id", props?.object?.id);
    // other_business ...
    if (otherBusinessFormList.length > 0) {
      otherBusinessFormList.map((data, index) => {
        dataForm.append(
          `other_business[${index}][other_business_id]`,
          data.otherBusinessId
        );
        dataForm.append(
          `other_business[${index}][form_date]`,
          formatDate(data.formDate)
        );
        dataForm.append(
          `other_business[${index}][form_number]`,
          data.formNumber
        );
        dataForm.append(`other_business[${index}][issuer]`, data.issuer);
        dataForm.append(`other_business[${index}][amount]`, data.amount);
        dataForm.append(`other_business[${index}][currency]`, data.currency);
        dataForm.append(`other_business[${index}][note]`, data.note);
      
      });
    }
    if (countImage.length > 0)
    countImage.map((image, index) => {
      if (image.file) dataForm.append(`images[${index}][file]`, image.file);
      dataForm.append(`images[${index}][file_type]`, image.fileType);
      dataForm.append(`images[${index}][image_for_what]`, image.ImageForWhat);
      // dataForm.append("images[][image_for_what]", image.ImageForWhat);
    });

    let data = null;
    try {
      data = await axios({
        method: "post",
        url: ApiSetting.apiUrl + "/other_business_form/store",
        data: dataForm,
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      });

      // console.log("data", data);
      if (data) {
        if (data.data.status == 200) {
          props.advanceSearch()
          setsnackBar({
            ...snackBar,
            open: true,
            severity: "success",
            message: data.data.message,
          });
        } else if (data.data.status == 500) {
          if (data.data.data) {
            setsnackBar2({
              ...snackBar2,
              open: true,
              severity: "warning",
              message: data.data.data,
            });
          } else {
            setsnackBar({
              ...snackBar,
              open: true,
              severity: "warning",
              message: data.data.message,
            });
          }
        } else {
          setsnackBar({
            ...snackBar,
            open: true,
            severity: "warning",
            message: data.data.message,
          });
        }
      }
      setLoading(false);
    } catch (err) {
      console.log("data", data);
      setsnackBar({
        ...snackBar,
        open: true,
        severity: "error",
        message: err.message,
      });
      setLoading(false);
    }
  };

  //======================================================
  // ==============store data of other_business================

  const handleSetOtherBusinessFormList = (data) => {
    setOtherBusinessFormList(
      otherBusinessFormList.map((dataItem) => {
        if (data.index == dataItem.index) {
          return {
            ...data,
          };
        }
        return dataItem;
      })
    );
  };

 

  
  const [countImageList,setCountImageList]=useState(0);
  const  [filesObject,setFilesObject]=useState({
    index: 0,
    fileType: null,
    ImageForWhat: null,
    file: null,
    mem: null,
    imgURl: null,
    pdfCheck: 0,
  });

  const [loading3,setLoading3]=useState(false)

  const pushImageFiles = () => {
         if(countImage.lenght>0){
          let ch=0;
          countImage.map((itm)=>{
             if(itm?.file?.name==filesObject?.file?.name){
                ch=1; 
             }
          })

          if(ch==1){
            setsnackBar({
              ...snackBar,
              open: true,
              severity: "warning",
              message:
                "لا يمكنك رفع نفس الملف اكثر من مرة",
            });
            return;
          }
         }


    console.log("filesObject",filesObject);
    if(filesObject.file){
    setLoading3(true)
    console.log("countImage",countImage);
    setCountImage([...countImage,filesObject])
    setTimeout(()=>{
    setLoading3(false)
    },500)

    setFilesObject({  
      index: 0,
      fileType: null,
      ImageForWhat: null,
      file: null,
      mem: null,
      imgURl: null,
      pdfCheck: 0,
    })
    document.getElementById('Images').value=null;
  }else{
    setsnackBar({
      ...snackBar,
      open: true,
      severity: "warning",
      message:
        "يجب  ملئ البيانات الخاصة بالملف لاضافته",
    });
  }
}


const removeImage=(data)=>{
  console.log('done');

    if(countImage.length>0){
      console.log('done');
        setCountImage(countImage.filter((itm)=> itm.index!=data.index))
    }
}


  return (
    <>
      {/*###==>other_business list ...  */}
      <h4
        style={{
          marginRight: "10px",
          color: "#5f7b8a",
        }}
      >
        المقتبسات والتصاريح
      </h4>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexFlow: "row wrap",
          width: "98%",
          minWidth: 200,
          border: "1px solid",
          borderColor: "#5f7b8a",
          borderRadius: 10,
          margin: 10,
          paddingBottom: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            minWidth: 200,
            marginTop: 10,
            paddingLeft: 10,
            paddingTop: 10,
            paddingRight: 10,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FormControl fullWidth>
            <AddCircleSharpIcon
              onClick={() => {
                setOtherBusinessFormList((count) => [
                  ...count,
                  {
                    index: otherBusinessFormList.length + 1,
                    otherBusinessId: null,
                    formNumber: null,
                    formDate: "",
                    issuer: "",
                    amount: null,
                    currency: "",
                    note: "",
                  },
                ]);
              }}
              style={{
                fontSize: 40,
                // borderRadius: "10px",
                // backgroundColor: Styles.Colors.MOF_Modal_BGcolor,
                color: Styles.Colors.MOF_Modal_BGcolor,
                cursor: "pointer",
              }}
            />
          </FormControl>

          <Typography className="fontForError"></Typography>
        </div>

        {otherBusinessFormList.length > 0
          ? otherBusinessFormList.map((data) => (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexFlow: "row wrap",
                  width: "100%",
                  minWidth: 200,
                  // border: "1px solid",
                  borderColor: "#5f7b8a",
                  borderRadius: 10,
                  margin: 10,
                  paddingBottom: 10,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    // width: "20%",
                    flex: 0.1,
                    // minWidth: 200,
                    marginTop: 10,
                    paddingLeft: 10,
                    paddingTop: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <RemoveCircleSharpIcon
                      onClick={() => {
                        setOtherBusinessFormList(
                          otherBusinessFormList.filter(
                            (itm) => itm.index != data.index
                          )
                        );
                      }}
                      style={{
                        fontSize: 40,
                        // borderRadius: "10px",
                        // backgroundColor: Styles.Colors.MOF_Modal_BGcolor,
                        color: Styles.Colors.MOF_Modal_BGcolor,
                        cursor: "pointer",
                      }}
                    />
                  </FormControl>

                  <Typography className="fontForError"></Typography>
                </div>

                <div
                  style={{
                    display: "flex",
                    // width: "20%",
                    flex: 1,
                    minWidth: 200,
                    marginTop: 10,
                    paddingLeft: 10,
                    paddingTop: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <InputLabel id="career-simple-select-label">
                      نوع المقتبس / التصريحة
                    </InputLabel>
                    <Select
                      labelId="career-simple-select-label"
                      id="career-simple-select"
                      value={data.otherBusinessId}
                      label="نوع المقتبس / التصريحة"
                      onChange={(e) => {
                        const updatedData = {
                          ...data,
                          otherBusinessId: e.target.value,
                        };
                        handleSetOtherBusinessFormList(updatedData);
                      }}
                    >
                      {otherBusinessesList?.map((otherBusiness) => {
                        return (
                          <MenuItem
                            value={otherBusiness.id}
                            key={otherBusiness.id + "_type"}
                          >
                            {otherBusiness.type}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>

                  <Typography className="fontForError"></Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "33%",
                    // flex: 1,
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="الرقم"
                      variant="outlined"
                      value={data.formNumber}
                      onChange={(e) => {
                        const updatedData = {
                          ...data,
                          formNumber: e.target.value,
                        };
                        handleSetOtherBusinessFormList(updatedData);
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError"></Typography>
                </div>

                <div
                  style={{
                    display: "flex",
                    width: "33%",
                    // flex: 1,
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DesktopDatePicker
                        label="التاريخ"
                        inputFormat="dd/MM/yyyy"
                        value={(typeof data.formDate === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(data.formDate)) ? new Date(Number(data.formDate.slice(0,4)), Number(data.formDate.slice(5,7))-1, Number(data.formDate.slice(8,10))) : (data.formDate instanceof Date ? data.formDate : null)}
                        onChange={(formDate) => {
                          const updatedData = {
                            ...data,
                            formDate: formDate,
                          };
                          handleSetOtherBusinessFormList(updatedData);
                        }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </FormControl>
                  <Typography className="fontForError"></Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    // width: "20%",
                    flex: 1,
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="جهة الاصدار "
                      variant="outlined"
                      value={data.issuer}
                      onChange={(e) => {
                        const updatedData = {
                          ...data,
                          issuer: e.target.value,
                        };
                        handleSetOtherBusinessFormList(updatedData);
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError"></Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "33%",
                    // flex: 1,
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="المبلغ"
                      variant="outlined"
                      type={"number"}
                      value={data.amount}
                      onChange={(e) => {
                        const updatedData = {
                          ...data,
                          amount: e.target.value,
                        };
                        handleSetOtherBusinessFormList(updatedData);
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError"></Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    // width: "20%",
                    flex: 1,
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="العملة "
                      variant="outlined"
                      multiline
                      value={data.currency}
                      onChange={(e) => {
                        const updatedData = {
                          ...data,
                          currency: e.target.value,
                        };
                        handleSetOtherBusinessFormList(updatedData);
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError"></Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    // width: "20%",
                    flex: 1,
                    minWidth: 200,
                    marginTop: 10,
                    paddingTop: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FormControl fullWidth>
                    <TextField
                      label="الملاحظات "
                      variant="outlined"
                      multiline
                      value={data.note}
                      onChange={(e) => {
                        const updatedData = {
                          ...data,
                          note: e.target.value,
                        };
                        handleSetOtherBusinessFormList(updatedData);
                      }}
                    />
                  </FormControl>
                  <Typography className="fontForError"></Typography>
                </div>
              </div>
            ))
          : null}
      </div>

      {/*###==>images upload ...  */}
      <h4
        style={{
          marginRight: "10px",
          color: "#5f7b8a",
        }}
      >
        المستمسكات{" "}
      </h4>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexFlow: "row wrap",
          width: "98%",
          minWidth: 200,
          border: "1px solid",
          borderColor: "#5f7b8a",
          borderRadius: 10,
          margin: 10,
          paddingBottom: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            minWidth: 200,
            marginTop: 10,
            paddingLeft: 10,
            paddingTop: 10,
            paddingRight: 10,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FormControl fullWidth>
            <AddCircleSharpIcon
              className="hoverPluse"
              onClick={() => {
                if(countImageList==0)
                  setCountImageList(1)
              }}
              style={{
                fontSize: 40,
                color: Styles.Colors.MOF_Modal_BGcolor,
                cursor: "pointer",
              }}
            />
          </FormControl>

          <Typography className="fontForError"></Typography>
        </div>

        {countImageList ==1  ?
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexFlow: "row wrap",
              width: "100%",
              minWidth: 200,
              // border: "1px solid",
              borderColor: "#5f7b8a",
              borderRadius: 10,
              margin: 10,
              paddingBottom: 10,
            }}
          >
            <div
              style={{
                display: "flex",
                // width: "20%",
                flex: 1,
                minWidth: 200,
                marginTop: 10,
                paddingLeft: 10,
                paddingTop: 10,
                paddingRight: 10,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FormControl fullWidth>
                <InputLabel id="career-simple-select-label">
                  نوع الملف
                </InputLabel>
                <Select
                  labelId="career-simple-select-label"
                  id="career-simple-select"
                  value={filesObject.fileType?filesObject.fileType:null}
                  label="نوع الملف "
                  onChange={(e) => {
                    // setFileType(e.target.value);
                    
                    if (e.target.value == "image") {
                      console.log(e.target.value);
                          setFilesObject({
                          ...filesObject,
                          index:countImage.length+1,
                          fileType :e.target.value,
                          mem: "image/png,image/jpg,image/jpeg",
                          })

                    } else if (e.target.value == "pdf") {
                      setFilesObject({
                        ...filesObject,
                        index:countImage.length+1,
                        fileType:e.target.value,
                        mem: "application/pdf",
                        })
                      
                    }
                  }}
                >
                  <MenuItem value={"image"}>{"صورة"}</MenuItem>
                  <MenuItem value={"pdf"}>{"ملف pdf"}</MenuItem>
                </Select>
              </FormControl>

              <Typography className="fontForError"></Typography>
            </div>
            {/* {filesObject.fileType == "image" ? (
              <div
                style={{
                  display: "flex",
                  // width: "20%",
                  flex: 1,
                  minWidth: 200,
                  marginTop: 10,
                  paddingLeft: 10,
                  paddingTop: 10,
                  paddingRight: 10,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <FormControl fullWidth>
                  <InputLabel id="career-simple-select-label">
                    يرجا اختيار اسم الصورة
                  </InputLabel>
                  <Select
                    labelId="career-simple-select-label"
                    id="career-simple-select"
                    value={filesObject.ImageForWhat?filesObject.ImageForWhat:null}
                    label="يرجا اختيار اسم الصورة"
                    onChange={(e) => {
                      setFilesObject({
                        ...filesObject,
                        index:countImage.length+1,
                        ImageForWhat: e.target.value,
                        })
                    
                    }}
                  >
                    <MenuItem value={"بطاقة الاحوال المدنية"}>
                      {"بطاقة الاحوال المدنية"}
                    </MenuItem>
                    <MenuItem value={"بطاقة السكن"}>
                      {"بطاقة سكن "}
                    </MenuItem>
                  </Select>
                </FormControl>

                <Typography className="fontForError"></Typography>
              </div>
            ) : null} */}
            <div
              style={{
                display: "flex",
                // width: "20%",
                flex: 1,
                minWidth: 200,
                marginTop: 10,
                paddingTop: 10,
                paddingLeft: 10,
                paddingRight: 10,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FormControl fullWidth>
                <span
                  // href="#"
                  onClick={() => {
                   if(filesObject.fileType){
                    document
                    .querySelector(".images")
                    .click();
                   }else{
                    setsnackBar({
                      ...snackBar,
                      open: true,
                      severity: "warning",
                      message: "يجب ان تختار نوع الملف",
                    });
                   }
                  }}
                >
                  <button class="boton">ارفع مستند</button>
                </span>
                <input
                  type="file"
                  id="Images"
                  className="images d-none"
                  name="images"
                  accept={filesObject.mem?filesObject.mem:null}
                  onChange={(e) => {
                    console.log(filesObject);
                    // e.target.click();
                    if(filesObject.fileType=='image'){
                      console.log('d2');
                      setFilesObject({
                        ...filesObject,
                        index:countImage.length+1,
                        file: e.target.files[0],
                        mem: "image/png,image/jpg,image/jpeg",
                        imgURl: window.URL.createObjectURL(e.target.files[0]),
                        pdfCheck: 0,
                        })
                    }else if(filesObject.fileType=='pdf'){
                      console.log('d1');
                      setFilesObject({
                        ...filesObject,
                        index:countImage.length+1,
                        file: e.target.files[0],
                        mem: "application/pdf",
                        imgURl:"https://play-lh.googleusercontent.com/BkRfMfIRPR9hUnmIYGDgHHKjow-g18-ouP6B2ko__VnyUHSi1spcc78UtZ4sVUtBH4g",
                        pdfCheck: 1,
                        })
                    }

                  }}
                />
              </FormControl>
              <Typography className="fontForError"></Typography>
            </div>

            <div
              style={{
                display: "flex",
                // width: "20%",
                flex: 1,
                minWidth: 200,
                marginTop: 10,
                paddingLeft: 10,
                paddingTop: 10,
                paddingRight: 10,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FormControl fullWidth>
              <Button
                  variant="contained"
                  style={{
                  backgroundColor: "#5f7b8a",
                  width: "40%",
                  fontSize: "20px",
                }}
                onClick={() => {
                //  sentDateOfForm();
                pushImageFiles();
                  
                }}
    >
          {!loading3 ? (
        "أضافة"
      ) : (
        <div class="spinner-border " role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      )}
    </Button>
              </FormControl>

              <Typography className="fontForError"></Typography>
            </div>
          </div>
          : null}

        { countImage.length>0 ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexFlow: "row wrap",
              width: "100%",
              minWidth: 200,
              border: "1px solid",
              borderColor: "#5f7b8a",
              borderRadius: 10,
              margin: 10,
              paddingBottom: 10,
              justifyContent: "start",
              alignItems: "center",
              paddingTop: 10,
              paddingRight: 10,
              overflowX: "scroll",
            }}
          >
            {countImage.map((data) => {
              
                return (
                  <div className="ownerImage">
                    <div className="deleteBox">
                      <DeleteSharpIcon className="iconDelete" onClick={()=>removeImage(data)}/>
                    </div>
                  <img
                  className="imageThumb"
                    src={data.imgURl}
                    alt="imagem"
                    title="imagem"
                    width="100px"
                    height="100px"
                    style={{ margin: "5px" }}
                  /> 
                  </div>
                );
                
            })}
          </div>
        ) : null}
      </div>

      {/* snack alert box here ... */}
      <Snackbar
        open={snackBar.open}
        autoHideDuration={6000}
        onClose={() => {
          setsnackBar({ ...snackBar, open: false });
        }}
        anchorOrigin={{
          vertical: snackBar.vertical,
          horizontal: snackBar.horizontal,
        }}
      >
        <Alert
          onClose={() => {
            setsnackBar({ ...snackBar, open: false });
          }}
          severity={snackBar.severity}
          sx={{ width: "100%" }}
        >
          {snackBar.message}
        </Alert>
      </Snackbar>

      {/* snack alert box here ... */}
      <Snackbar
        sx={{ height: "100%" }}
        open={snackBar2.open}
        // autoHideDuration={6000}
        onClose={() => {
          setsnackBar2({ ...snackBar2, open: false });
        }}
        anchorOrigin={{
          vertical: snackBar2.vertical,
          horizontal: snackBar2.horizontal,
        }}
      >
        <Alert
          onClose={() => {
            setsnackBar2({ ...snackBar2, open: false });
          }}
          severity={snackBar2.severity}
          sx={{ width: "100%" }}
        >
          {snackBar2.message?.length > 0
            ? snackBar2.message.map((mes) => <p>{mes}</p>)
            : ""}
        </Alert>
      </Snackbar>

      {/* ###==> submit button here...  */}
      <div
        style={{
          display: "flex",
          marginTop: 10,
          backgroundColor: "#fefefe",
          paddingLeft: 10,
          paddingRight: 10,
          paddingBottom: 30,

          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          variant="contained"
          style={{
            backgroundColor: "#5f7b8a",
            width: "40%",
            fontSize: "20px",
          }}
          onClick={() => {
            submit();
          }}
        >
          {!loading ? (
            "أضافة"
          ) : (
            <div class="spinner-border " role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          )}
        </Button>
      </div>
    </>
  );
}

export default OtherBusinessFormList;
